var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgByReceiver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.997 6.1 18 11.68v.245c0 2.687-1.63 4.276-4.386 4.276H6.387C3.629 16.2 2 14.61 2 11.924V6.07C2 3.383 3.63 1.8 6.387 1.8h7.224c2.757 0 4.386 1.583 4.386 4.27v.03z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.379 6.74c0 1.41-1.13 2.54-2.54 2.54-1.41 0-2.54-1.13-2.54-2.54 0-1.41 1.13-2.54 2.54-2.54 1.41 0 2.54 1.13 2.54 2.54zM6 12.156c0-1.306 1.768-1.632 3.839-1.632 2.081 0 3.838.338 3.838 1.644 0 1.306-1.768 1.632-3.838 1.632C7.757 13.8 6 13.462 6 12.156z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgByReceiver);
export default __webpack_public_path__ + "static/media/by_receiver.9e7c8ec7bc859cbe92dcb72265817acd.svg";
export { ForwardRef as ReactComponent };